module.exports = __webpack_public_path__ + "img/pic_04.8f6d0b7a.png";